import { translate } from "ui/i18n";

export const contextOfUseFilters = [
  { value: "INTRO", text: translate("ns1:Techniques.INTRO") },
  { value: "CORE", text: translate("ns1:Techniques.CORE") },
  { value: "CONCLUSION", text: translate("ns1:Techniques.CONCLUSION") },
];

export const typesFilters = [
  { value: "ice_breaker", text: translate("ns1:Techniques.ice_breaker") },
  { value: "equipes", text: translate("ns1:Techniques.equipes") },
  { value: "brainstorming", text: translate("ns1:Techniques.brainstorming") },
  { value: "projects", text: translate("ns1:Techniques.projects") },

  {
    value: "evaluation",
    text: translate("ns1:Techniques.evaluation"),
  },
  { value: "vote", text: translate("ns1:Techniques.vote") },
];

export const objectiveFilters = [
  {
    value: "AMELIORER",
    text: translate("ns1:Techniques.Filters.AMELIORER"),
  },
  {
    value: "COMMUNIQUER",
    text: translate("ns1:Techniques.Filters.COMMUNIQUER"),
  },
  { value: "COHESION", text: translate("ns1:Techniques.Filters.COHESION") },
  { value: "LIENS", text: translate("ns1:Techniques.Filters.LIENS") },
  { value: "CADRE", text: translate("ns1:Techniques.Filters.CADRE") },
  { value: "VISION", text: translate("ns1:Techniques.Filters.VISION") },
  { value: "DECIDER", text: translate("ns1:Techniques.Filters.DECIDER") },
  { value: "DYNAMISER", text: translate("ns1:Techniques.Filters.DYNAMISER") },
  { value: "EVALUER", text: translate("ns1:Techniques.Filters.EVALUER") },
  { value: "ECHANGER", text: translate("ns1:Techniques.Filters.ECHANGER") },
  { value: "IDEES", text: translate("ns1:Techniques.Filters.IDEES") },
  { value: "PB", text: translate("ns1:Techniques.Filters.PB") },
  { value: "ACTION", text: translate("ns1:Techniques.Filters.ACTION") },
  { value: "USAGE", text: translate("ns1:Techniques.Filters.USAGE") },
];

export const supportsObjectiveFilters = [
  {
    value: "VCLASSER",
    text: translate("ns1:VisualSupport.Filters.CLASSER"),
  },
  {
    value: "VPRIORISER",
    text: translate("ns1:VisualSupport.Filters.PRIORISER"),
  },
  { value: "VCARTO", text: translate("ns1:VisualSupport.Filters.CARTO") },
  {
    value: "VINSPIRER",
    text: translate("ns1:VisualSupport.Filters.INSPIRER"),
  },
  {
    value: "VPOSITION",
    text: translate("ns1:VisualSupport.Filters.POSITION"),
  },
  {
    value: "VPROJETER",
    text: translate("ns1:VisualSupport.Filters.PROJETER"),
  },
  { value: "VDECIDER", text: translate("ns1:VisualSupport.Filters.DECIDER") },
];

export const modalitiesFilters = [
  { value: "onsite", text: translate("ns1:Techniques.Filters.OnSite") },
  { value: "remote", text: translate("ns1:Techniques.Filters.Remote") },
];

export const durationFilters = [
  { value: "lte120", text: translate("ns1:Techniques.Filters.LessThan2H") },
  { value: "lte240", text: translate("ns1:Techniques.Filters.Between2Hand4H") },
  {
    value: "lte1440",
    text: translate("ns1:Techniques.Filters.Between4AndADay"),
  },
  { value: "gte1440", text: translate("ns1:Techniques.Filters.MoreThanADay") },
];

export const categoryFilters = [
  {
    value: "FOND",
    text: translate("ns1:Tutorials.Types.FOND"),
  },
  { value: "TECH", text: translate("ns1:Tutorials.Types.TECH") },
  { value: "SKILLS", text: translate("ns1:Tutorials.Types.SKILLS") },
  {
    value: "NUM",
    text: translate("ns1:Tutorials.Types.NUM"),
  },
];

export const levelFilters = [
  { value: "facile", text: translate("ns1:Techniques.Filters.ToBegin") },
  {
    value: "intermediaire",
    text: translate("ns1:Techniques.Filters.WithPractice"),
  },
];
